/**
 * تنظیمات فرانت گفتگو — فقط همین فایل را ویرایش کنید.
 */
export const API_ORIGIN = "https://afgexchange.online";
export const CHAT_API = `${API_ORIGIN}/api/chat/index.php`;

// سرور realtime (Node). اگر پشت nginx روی همان دامنه است، همین مقدار درست است.
export const SOCKET_URL = API_ORIGIN;
export const SOCKET_PATH = "/socket.io";

// تماس رایگان P2P: STUN عمومی. برای عبور از NAT/فایروال‌های سخت، بعداً TURN اضافه کنید:
// { urls: "turn:turn.example.com:3478", username: "user", credential: "pass" }
export const ICE_SERVERS: RTCIceServer[] = [
  { urls: "stun:stun.l.google.com:19302" },
  { urls: "stun:stun1.l.google.com:19302" },
  // سرور TURN عمومی و رایگان (فقط برای آزمایش؛ برای استفاده جدی TURN اختصاصی بگیرید)
  { urls: ["turn:openrelay.metered.ca:80", "turn:openrelay.metered.ca:443", "turns:openrelay.metered.ca:443?transport=tcp"], username: "openrelayproject", credential: "openrelayproject" },
];
export const MAX_CALL_PARTICIPANTS = 4;

/** توکن ورود فعلی کاربر؛ اگر سیستم شما کلید دیگری دارد اینجا اضافه کنید. */
export const getToken = (): string =>
  localStorage.getItem("auth_token") || localStorage.getItem("token") || "";

export const fileUrl = (u?: string | null): string => (!u ? "" : u.startsWith("http") ? u : API_ORIGIN + u);
